import { useRef } from 'react';

/**
 * Hook to provide refs for gallery images.
 * Native lazy loading is now used via the `loading="lazy"` attribute on img elements,
 * so this hook only provides the refs array for potential future use.
 */
export function useLazyLoading(
  _enabled: boolean,
  _filteredItems: unknown[]
): React.MutableRefObject<(HTMLImageElement | null)[]> {
  const imageRefs = useRef<(HTMLImageElement | null)[]>([]);
  return imageRefs;
}
